export const classes = {
  trigger:
    'place-center size-10 rounded-full border border-black/10 bg-white/70 text-taupe-2 shadow-aurora-card backdrop-blur-lg transition-colors hover:text-taupe-3 dark:border-white/10 dark:bg-[#211d2f]/70 dark:text-mauve-2 dark:hover:text-mauve-1',
  sectionLabel:
    'px-4 pb-1 pt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-taupe-1 dark:text-mauve-3',
  appearance: 'px-3 py-1 mb-1',
};
